import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes.
 *
 * @param inputs - Class values to be merged.
 * @returns Merged class string.
 *
 * @example
 * ```ts
 * import { cn } from '@/utils/tailwind';
 *
 * const Component = ({ someExtraClassName }: { someExtraClassName?: string }) => {
 *   const someCondition = true;
 *   const someOtherCondition = true;
 *
 *   return (
 *     <div className={cn(
 *       'p-4',
 *       someCondition && 'bg-blue-500',
 *       someOtherCondition ? 'text-white' : 'text-black',
 *       someExtraClassName
 *     )}>
 *       Hello World
 *     </div>
 *   );
 * }
 * ```
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
